/**
 * How far above its feet a creature's art reaches (R-0089). A creature's sheet is its own size (a Spider's frame is 64
 * high with its pivot 42 down, a Pot Creature's 128 with its pivot 93 down), so the world-attached UI that stands over
 * a character's head at the default 35 pixels would stand inside a tall creature or float over a small one. The
 * scene measures each creature sheet once, from its idle strip, the first time it draws one.
 */

/**
 * The world pixels between a sheet's pivot and the topmost opaque row of any frame in a strip of its frames.
 *
 * @param pixels The strip's RGBA pixels, rows from the top.
 * @param width The strip's width in pixels.
 * @param height The strip's height in pixels.
 * @param frameHeight One frame's height; frames stacked in rows are each measured from their own top.
 * @param pivotY The pivot's row within a frame, which stands on the entity's feet.
 * @returns How far the art reaches above the feet, 0 for a strip with no art above its pivot.
 */
export function headAboveFeet(pixels: Uint8ClampedArray, width: number, height: number, frameHeight: number, pivotY: number): number {
  let top = frameHeight;
  for (let y = 0; y < height; y += 1) {
    const row = y % frameHeight;
    if (row >= top) {
      continue;
    }
    for (let x = 0; x < width; x += 1) {
      if ((pixels[(y * width + x) * 4 + 3] as number) > 0) {
        top = row;
        break;
      }
    }
  }
  return Math.max(0, pivotY - top);
}
